import { executePost } from "../ServiceMethods";
import {
  removeUserCredentials,
  userId,
  getactiveBuId,
  getBusinessSwitched,
} from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

export const MessageDetailApi = async (cb) => {
  const id = userId();
  const is_switched_value = getBusinessSwitched();
  const acitve_business_id = getactiveBuId();
  // console.log("is_switched_value ===",acitve_business_id,id)
  let payload = {
    bu_id: is_switched_value === "true" ? acitve_business_id : id,
    api_method: "get",
  };
  try {
    const activeVouchers = await executePost(
      "/chat/message/businessUser",
      payload,
    );
    const activeVouchersData = activeVouchers.data ? activeVouchers.data : {};
    return activeVouchersData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
